import { DeepPartial, get } from "react-hook-form";
import { isString } from "./utils";
import { FilterValues, Names } from "./types";

export default <T>(
  names: string | string[] | undefined,
  _names: Names,
  formValues?: FilterValues,
  isGlobal?: boolean,
  defaultValue?: DeepPartial<T> | unknown
) => {
  if (isString(names)) {
    isGlobal && _names.watch.add(names);
    return get(formValues, names, defaultValue);
  }

  if (Array.isArray(names)) {
    return names.map(
      (fieldName) => (
        isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)
      )
    );
  }

  isGlobal && (_names.watchAll = true);
  return formValues;
};
